import { render, staticRenderFns } from "./department3.vue?vue&type=template&id=78cf30d8&scoped=true&"
import script from "./department3.vue?vue&type=script&lang=js&"
export * from "./department3.vue?vue&type=script&lang=js&"
import style0 from "./department3.vue?vue&type=style&index=0&id=78cf30d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cf30d8",
  null
  
)

export default component.exports